import React from "react";

export default function ProductCard({ title, description, image, symbol }) {
  return (
    <div className="productCard">
      <div
        className="image"
        style={{
          backgroundImage: `url(${image})`
        }}>
        <div className="symbol">{symbol}</div>
      </div>
      <div className="content">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
}
